// extracted by mini-css-extract-plugin
export default {"wrapper":"j2A4y","content-wrapper":"MHojP","logo":"Z0wjo","logo-wrapper":"Mkgrs","logo-text":"Ecb6d"};